export { PaytableDesktop } from "./PaytableDesktop";
export { PaytableMobile } from "./PaytableMobile";
